import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

const EnquiryStatus = (props) => {
  const { t, step, isActive } = props;

  const typeColor = {
    1: "#0A4986",
    2: "#F08046",
    4: "#E83F1E",
    6: "#CCCCCC",
    5: "#32A728",
    9: "#F08046", // delete after this when field step added in db
  };
  const typeText = {
    1: "ENQUIRY_STATUS_TO_PROCESS",
    2: "ENQUIRY_STATUS_QUOTATION",
    4: "ENQUIRY_STATUS_DELETED",
    6: "ENQUIRY_STATUS_CANCELED",
    5: "ENQUIRY_STATUS_QUOTED",
    9: "ENQUIRY_STATUS_REQUOTATION", // delete after this when field step added in db
  };

  return (
    <>
      <DivBackgroundOpacity opacity={isActive === true ? 1 : "0.2"}>
        <ColumnButton
          border={typeColor[step]}
          background={typeColor[step]}
          marginRight="10px"
        >
          <span>{t(typeText[step])}</span>
        </ColumnButton>
      </DivBackgroundOpacity>
    </>
  );
};

EnquiryStatus.defaultProps = {
  isActive: true,
};

EnquiryStatus.propTypes = {
  t: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  step: PropTypes.number.isRequired,
};

export default withTranslation()(EnquiryStatus);
